


















































































import { Component, Mixins } from 'vue-property-decorator';
import { RawLocation, Route } from 'vue-router';
import SubmitTotals from '@/components/familyPortal/checkout/checkoutSubmit/SubmitTotals.vue';
import SubmitCard from '@/components/familyPortal/checkout/checkoutSubmitCard/SubmitCard.vue';
import Stepper, { CheckoutStep } from '@/components/familyPortal/checkout/stepper/Stepper.vue';
import InfoAlert from '@/components/familyPortal/checkout/infoAlert/InfoAlert.vue';
import APP_CONST from '@/constants/AppConst';
import { ScreenText } from '@/lang/ScreenText';
import { PaymentOptions, SubmitCartItem } from '@/Model/checkout/cart/types';
import { PaymentOnboardingStatus } from '@/Model/sessions/catalogTypes';
import AccountSettings from '@/mixins/accountSettings.mixin';
import DeviceWidthCheckerMixin from '@/mixins/deviceWidthChecker.mixin';
import { sortSubmitCartItems } from '@/services/checkout/cart/helpers';
import cartStore from '@/store/modules/checkout/cart/module';
import commonEntry from '@/store/modules/commonEntry';
import APP_UTILITIES from '@/utilities/commonFunctions';

Component.registerHooks(['beforeRouteLeave']);

@Component({
  components: {
    Stepper,
    SubmitCard,
    SubmitTotals,
    InfoAlert
  }
})
export default class CheckoutDone extends Mixins(DeviceWidthCheckerMixin, AccountSettings) {
  public readonly CheckoutStep = CheckoutStep;
  public readonly screenText = new ScreenText();
  public readonly APP_ROUTES = APP_CONST.APP_ROUTES;

  isCustomPaymentEnabled = false;

  public readonly PAYMENT_OPTIONS = PaymentOptions;

  isAutomaticDiscountEnabled = false;



  async created() {
    //FF: Automatic Discounts
    const automaticDiscountFlag = await APP_UTILITIES.getFeatureFlag(APP_CONST.FEATURE_KEYS.automaticDiscounts);
    this.isAutomaticDiscountEnabled = automaticDiscountFlag;

    const customPaymentFlag = await APP_UTILITIES.getFeatureFlag(APP_CONST.FEATURE_KEYS.customPayments);
    this.isCustomPaymentEnabled = customPaymentFlag;

    APP_UTILITIES.segmentTrackEvent(APP_CONST.SEGMENT_EVENTS.CHECKOUT_COMPLETE.checkoutComplete);

  }


  get isPaymentVisible(): boolean {
    if(cartStore.customCheckout){
      return this.isCustomPaymentEnabled && cartStore.customCheckout.isEnabled ;
    }
    else {
      return false;
    }
  }

  get paymentMethodInstructions(): string {
    return cartStore.customCheckout
      ? cartStore.customCheckout.instructions
      : '';
  }

  get paymentMethodName(): string {
    return cartStore.customCheckout
      ? cartStore.customCheckout.name
      : '';
  }

  get selectedPaymentOption(): PaymentOptions {
    return cartStore.selectedPayment;
  }

  get title(): string {
    return this.screenText.getScreenText('CHECKOUT_STEP_DONE_TITLE');
  }

  get subtext(): string {
    return this.screenText.getScreenText('CHECKOUT_STEP_DONE_SUBTEXT');
  }

  get subtextHomepageLink(): string {
    return this.screenText.getScreenText('CHECKOUT_STEP_DONE_SUBTEXT_HOMEPAGE_LINK_TEXT');
  }

  get notificationBoxTitleText(): string {
    return this.screenText.getScreenText('CHECKOUT_STEP_DONE_NOTIFICATION_TITLE_TEXT');
  }

  get notificationBoxInfoText(): string {
    return this.screenText.getScreenText('CHECKOUT_STEP_DONE_NOTIFICATION_INFO_TEXT');
  }

  get sortedCartItems(): Array<SubmitCartItem> {
    return cartStore.submittedCart
      ? sortSubmitCartItems(cartStore.submittedCart.cartItems)
      : [];
  }

  get isCartTotalFree() {
    const value = cartStore.submittedCart
      ? cartStore.submittedCart.totals.total
      : (cartStore.total || 0);
    return value === 0;
  }

  get hasOnlinePayments(): boolean {
    return commonEntry.accountPaymentOnboardingStatus === PaymentOnboardingStatus.Complete;
  }

  beforeRouteLeave(_to: Route, _from: Route, next: ((to?: false | void | RawLocation) => void)) {
    cartStore.RESET_SUBMITTED_CART();
    next();
  }
}
